<script lang="ts">
    import LoadingSpan from './LoadingSpan.svelte';

    export let design = 'square';
</script>

<div>
    <LoadingSpan design={design} />
</div>
